// Generated by ReScript, PLEASE EDIT WITH CARE


let defaultPostalCode = {
  iso: "",
  format: "",
  regex: ""
};

export {
  defaultPostalCode,
}
/* No side effect */
